import { createContext, useContext } from 'react';
/** @internal Context for banner components to share configuration. */
export const BannerContext = createContext(null);
export function useBannerContext() {
    const context = useContext(BannerContext);
    if (!context) {
        throw new Error('useBannerContext must be used within a Banner component');
    }
    return context;
}
//# sourceMappingURL=useBannerContext.js.map